import IdentityTagSelectionHeader from './IdentityTagSelectionHeader';

export default IdentityTagSelectionHeader;
